<template>
  <div class="flex-shrink-0 flex items-stretch p-4 bg-blue-500 text-white">
    <div class="mr-4 flex flex-col justify-center">
      <NumImage :main-loaded="!!result" :url="numUriString" />
    </div>
    <div class="flex-1 flex flex-col justify-center last:mb-0">
      <h2 class="mb-1">
        <SkeletonLine :val="result" v-slot:default="{ val }" variant="light">
          {{ val.name }}
        </SkeletonLine>
      </h2>
      <p>
        <SkeletonLine :val="result" v-slot:default="{ val }" variant="light">
          {{ val.slogan || val.description || val.bio }}
        </SkeletonLine>
      </p>
    </div>
  </div>
</template>

<script>
import NumImage from "@/views/Home/NumImage";
import SkeletonLine from "@/components/SkeletonLine";

export default {
  name: "HeaderCard",
  components: {
    NumImage,
    SkeletonLine,
  },
  props: {
    numUriString: String,
    result: Object,
  },
};
</script>
